/*
  Slide-out cart after an Easify add-on "Add to cart" (Hype Locker UK, added 17 Oct 2026).

  Why: when a strap (an add-on product kept as its own cart line) is selected, the Easify Product Options app adds the
  watch and the strap itself, so the AMP slide-out never hears about it. Easify then follows the theme's "cart type"
  setting. That setting is "page" because the slide-out comes from the AMP app, not from the theme, so Easify sends
  the customer to the cart page. Easify has no AMP setting.

  What this does: tells Easify the cart is a drawer, gives Easify the element it opens a drawer through, and opens the
  AMP slide-out from that element. It only acts on pages where Easify has loaded (window.TPOConfigs exists) and falls
  back to the cart page if the AMP functions are missing. No theme setting or app setting is changed.

  Load order matters: Easify reads cart_type once when it starts. This file is loaded with defer in the head, which runs
  before Easify's own module script at the end of the body. If this stops working after an Easify update, delete the
  script line from layout/theme.liquid and Easify goes back to sending customers to the cart page.
*/
(function () {
  'use strict';

  var config = window.TPOConfigs;
  if (!config || window.hlEasifyAmpBridge) return;
  window.hlEasifyAmpBridge = true;

  config.cart_type = 'drawer';

  function openSlideOut() {
    if (typeof window.SLIDECART_OPEN !== 'function') {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      window.SLIDECART_OPEN();
    }

    if (typeof window.SLIDECART_UPDATE === 'function') {
      window.SLIDECART_UPDATE(open); // refresh AMP's copy of the cart, then open
      setTimeout(open, 1500); // never leave the customer with nothing happening
    } else {
      open();
    }
  }

  // Easify looks for a cart-notification or cart-drawer element and calls renderContents() on it after it has added the items.
  // Only cart-notification is created here: the theme's own product form checks for cart-drawer, and the theme never defines either element.
  var bridge = document.createElement('cart-notification');
  bridge.hidden = true;
  bridge.setAttribute('aria-hidden', 'true');
  bridge.style.display = 'none';
  bridge.renderContents = openSlideOut;
  document.body.appendChild(bridge);
})();
